import React, { lazy, memo, Suspense } from 'react';
import rem from '../../../utils/rem';
import { Icon } from '../../icon';
import { Flex, Box } from '../../primitives';
import { Fallback } from '../../fallback';
import { Props as BreakerProps } from '../breaker.types';

type Props = Pick<BreakerProps, 'illustration' | 'type'>;

const BreakerFavorite = lazy(() => import('../../svgs/svgr/BreakerFavorite'));

const BreakerIllustration = ({ type, illustration }: Props) => (
  <Box mb="medium">
    <Suspense fallback={<Fallback />}>
      {(() => {
        switch (type) {
          case 'FTI_SENT':
            return (
              <Flex
                borderWidth={2}
                borderStyle="solid"
                borderColor="caribbeanGreen"
                borderRadius="50%"
                size={rem(70)}
                justifyContent="center"
                alignItems="center"
              >
                <Icon
                  name="bubble-thin"
                  size={rem(31)}
                  color="caribbeanGreen"
                />
              </Flex>
            );
          case 'FTA':
            return (
              <Icon
                name="message-bubble-blink"
                size={rem(70)}
                color="caribbeanGreen"
              />
            );
          case 'FTA_RECEIVED':
            return illustration;
          case 'FAVORITE':
            return <BreakerFavorite height={rem(143)} width={rem(160)} />;
          case 'BLOCKED':
            return (
              <Icon
                name="no-chat"
                color={['primary', 'accent']}
                size={rem(70)}
              />
            );
          default:
            return <></>;
        }
      })()}
    </Suspense>
  </Box>
);

export default memo(BreakerIllustration);
